import { Injectable } from '@angular/core';
import { Customer } from './customer';
import { GatewayAPIService } from '../../core/gateway-api.service';
import { StorageService } from '../../core/storage/storageService';
import { Page } from '../../components/ui/filterable-table/tableViewAbstractComponent';

@Injectable({
  providedIn: 'root',
})
export class CustomerService {
  options = { authenticate: true, setRoot: true };

  constructor(
    private api: GatewayAPIService,
    private storage: StorageService,
  ) {}

  async patchCustomerContactInfo(customer: Partial<Customer>): Promise<any> {
    let data = {
      customerId: customer.id,
      firstName: customer.firstName,
      lastName: customer.lastName,
      emailAddress: customer.emailAddress,
      phone: customer.phone,
      firstNameChanged: true,
      lastNameChanged: true,
      emailAddressChanged: true,
      phoneNumberChanged: true,
    };

    return await this.patch(data);
  }

  deleteCustomer(id: string): Promise<boolean> {
    return this.api
      .apiCallSane(
        '/customer',
        'DELETE',
        this.api.getDefaultHeaders(),
        null,
        { customerId: id },
        this.options,
      )
      .then((response: boolean) => response);
  }

  get(data: any): Promise<Customer> {
    return this.api
      .apiCallSane(
        '/customer',
        'GET',
        this.api.getDefaultHeaders(),
        data,
        null,
        this.options,
      )
      .then((response: Partial<Customer>) => new Customer(response));
  }

  createCustomer(data: Partial<Customer>): Promise<Partial<Customer>> {
    return this.api
      .apiCallSane(
        '/customer',
        'POST',
        this.api.getDefaultHeaders(),
        null,
        { customer: data },
        this.options,
      )
      .then(
        (response: { customer: Partial<Customer> }) =>
          new Customer(response.customer),
      );
  }

  getPaged(query: string, data: any): Promise<Page<Customer>> {
    data.q = query;

    return this.api
      .apiCallSane(
        '/customers',
        'GET',
        this.api.getDefaultHeaders(),
        data,
        null,
        this.options,
      )
      .then(
        (response: Partial<Page<Customer>>) => new Page<Customer>(response),
      );
  }

  getCustomerById(id: string): Promise<Customer> {
    return this.get({ customerId: id });
  }

  patch(data: any): Promise<any> {
    let usr = this.storage.getCurrentUser();

    if (usr) {
      data.userId = usr.id;
    }

    return this.api.apiCallSane(
      '/customer',
      'PATCH',
      this.api.getDefaultHeaders(),
      null,
      data,
      this.options,
    );
  }

  /*
    getCustomersByMerchantId(id: string): Promise<Customer[]> {
        return this.api.apiCallSane(
            APISettings.ENDPOINT_CUSTOMERS,
            'POST',
            this.api.getDefaultHeaders(),
            null,
            { merchantId:id },
            this.options
        ).then((response: {customers:Partial<Customer>[]}) => response.customers.map(s => new Customer(s)));
    }
*/

  /*
    getCustomersByQuery(merchantId:string, query: string): Promise<Customer[]> {

        return this.api.apiCallSane(
            '/customer',
            'POST',
            this.api.getDefaultHeaders(),
            null,
            { merchantId:merchantId, query:query },
            this.options
        ).then((response: {customers:Partial<Customer>[]}) => response.customers.map(s => new Customer(s)));
    }
    */

  /* 
    createCustomer(data: any): Promise<string> {
        return this.api.apiCallSane(
            //'portal/cardholders/create/',
            APISettings.ENDPOINT_CUSTOMER_CREATE,
            'POST',
            this.api.getDefaultHeaders(),
            null,
            { customer: data },
            this.options
        )
    }
*/

  /*
    createCardHolder(data: any): Promise<CreateCardHolderResponse> {
            return this.api.apiCallSane(
                '/customer',
                'POST',
                this.api.getDefaultHeaders(),
                null,
                data,
                this.options
            ).then((c: Partial<CreateCardHolderResponse>) => new CreateCardHolderResponse(c));

        }
    }
*/
}
